import reportNoMovementsSagas from './reportNoMovements'
import reportIndividualNoMovementSagas from './reportIndividualNoMovements'

export default [
  ...reportNoMovementsSagas,
  ...reportIndividualNoMovementSagas,
]
